import { Controller } from "@hotwired/stimulus"
import { ScrollSmoother } from "gsap/ScrollSmoother"

export default class extends Controller {
  static targets = ["list", "btn", "input", "letterLink", "letterSection"]

  connect() {
    if (this.hasLetterSectionTarget) {
      this.letterObserver = new IntersectionObserver(this.onLetterSectionIntersect.bind(this), {
        rootMargin: "-20% 0px -70% 0px"
      })
      this.letterSectionTargets.forEach(section => this.letterObserver.observe(section))
    }
  } // end connect

  disconnect() {
    if (this.letterObserver) this.letterObserver.disconnect()
  } // end disconnect

  onLetterSectionIntersect(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return

      const link = this.letterLinkTargets.find(link => link.getAttribute("href") === `#${entry.target.id}`)
      if (!link) return

      this.letterLinkTargets.forEach(l => l.classList.toggle("active", l === link))
    })
  } // end onLetterSectionIntersect

  jumpToLetter(e) {
    e.preventDefault()

    const target = document.querySelector(e.currentTarget.getAttribute("href"))
    if (!target) return

    const header = document.getElementById("header")
    const headerOffset = header ? header.offsetHeight : 0
    const smoother = ScrollSmoother.get()

    if (smoother) {
      smoother.scrollTo(smoother.offset(target, "top top") - headerOffset, true)
    } else {
      const y = target.getBoundingClientRect().top + window.scrollY - headerOffset
      window.scrollTo({ top: y, behavior: "smooth" })
    }

    this.letterLinkTargets.forEach(link => {
      link.classList.toggle("active", link === e.currentTarget)
    })
  } // end jumpToLetter

  view(e) {
    const show = e.currentTarget.dataset.viewType 
    const activeClass = "active"

    this.listTarget.classList.remove("list-view", "grid-view")
    this.listTarget.classList.add(show)

    this.btnTargets.forEach(btn => {
      btn.classList.toggle(activeClass, btn === e.currentTarget)
    })
  } // end view

  searchToggle(e) {
    e.preventDefault()
    
    if (this.hasInputTarget) {
      this.inputTarget.classList.toggle("show")
      if (this.inputTarget.classList.contains("show")) {
        this.inputTarget.focus()
      }
    }
  } // end searchToggle
}
